import React, { type ReactNode } from "react";

export interface IFormTextRendererProps {
  formText?: ReactNode | ((value: unknown) => ReactNode);
  value?: unknown;
}

export const FormTextRenderer = ({
  formText,
  value,
}: IFormTextRendererProps) => {
  if (!formText) {
    return null;
  }
  return <>{typeof formText === "function" ? formText(value) : formText}</>;
};
